module.exports = __webpack_public_path__ + "static/media/install-android.b55f561c.png";